module.exports = __webpack_public_path__ + "5232fb33a1e227e8aba6e916799bb4eb.jpg";